module.exports = __webpack_public_path__ + "img/logo2a.bbde211b.png";